export class RequestCancelledError extends Error {
  constructor(isResponse: boolean) {
    super(`Запрос отменён при ${isResponse ? 'получении' : 'отправке'}`)
  }
}